@if (errorMessage) {
  <tidy-error-message
    [text]="errorMessage" />
}

@if (windowService.isDesktopRes) {
  <tidy-desktop-header>
    <div class="wrappable-container allow-wrap">
      <tidy-text
        [title]="'Payments'" />
      <tidy-text
        [helper]="'Most specific rules are applied first on inbound payments from guests.'" />
    </div>
    <div class="non-wrappable-right-aligned-container">
    </div>
  </tidy-desktop-header>
  <!-- Skeleton table while loading — rows float in with the entrance cascade;
       the real table below then replaces it in place, instantly (skipEntrance). -->
  @if (!isDataLoaded) {
    <tidy-table
      [skeletonLoading]="true"
      [columnslabels]="headers" />
  }
  @if (isDataLoaded && rows.length > 0) {
    <div class="desktop-flex-fill">
      <tidy-table
        #tidyTable
        [dataSource]="rows"
        [displayedColumns]="headers"
        [columnslabels]="headers"
        [allRowIsClickable]="true"
        [rowsToShow]="25"
        [showColumnLines]="false"
        [skipEntrance]="true"
        (sortChange)="sortChanged($event)"
        (cellClick)="onTableColumnClick($event)"
        [blockSorting]="true" />
    </div>
  }
  @if (isDataLoaded && rows.length === 0) {
    <tidy-alert>
      <tidy-row>
        <tidy-text [body]="getEmptyStateMessage()" />
      </tidy-row>
    </tidy-alert>
  }
}

@if (!windowService.isDesktopRes) {
  @if (!isDataLoaded) {
    <div style="width: 100%">
      <ion-skeleton-text
        animated="true"
        style="height: 75px; border-radius: 6px" />
    </div>
    <div style="width: 100%; padding-top: 1rem;">
      <ion-skeleton-text
        animated="true"
        style="height: 200px; border-radius: 6px" />
    </div>
  }
  @if (isDataLoaded) {
    @for (rule of rules; track rule.id) {
      <tidy-card>
        <tidy-row>
          <tidy-text
            [header]="rule.processing_instructions"
            [translate]="false" />
        </tidy-row>
        <tidy-row class="extra-top-padding">
          <tidy-grid>
            <ion-row>
              <ion-col size="6">
                <tidy-row>
                  <tidy-text [body]="'Property'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="rule.property_name || 'All Properties'"
                    [translate]="false" />
                </tidy-row>
              </ion-col>
              <ion-col size="6">
                <tidy-row>
                  <tidy-text [body]="'Channel'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="rule.channel || 'All Channels'"
                    [translate]="false" />
                </tidy-row>
              </ion-col>
            </ion-row>
            <ion-row class="extra-top-padding">
              <ion-col size="6">
                <tidy-row>
                  <tidy-text [body]="'Payment Method'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="rule.payment_method || 'All Methods'"
                    [translate]="false" />
                </tidy-row>
              </ion-col>
              <ion-col size="6">
                <tidy-row>
                  <tidy-text [body]="'Priority'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="rule.priority"
                    [translate]="false" />
                </tidy-row>
              </ion-col>
            </ion-row>
          </tidy-grid>
        </tidy-row>
      </tidy-card>
    }
    @if (rules.length === 0) {
      <tidy-alert>
        <tidy-row>
          <tidy-text [body]="getEmptyStateMessage()" />
        </tidy-row>
      </tidy-alert>
    }
  }
}
